/* eslint-disable no-param-reassign */
export default {
  addCards(state, cards) {
    state.visualSchedule.visual_schedule_cards_attributes = [
      ...state.visualSchedule.visual_schedule_cards_attributes,
      ...cards,
    ];
    state.visualSchedule.visual_schedule_cards_attributes.forEach((card, i) => {
      card.position = i + 1;
    });
  },

  removeCard(state, card) {
    const cardIndex = state.visualSchedule.visual_schedule_cards_attributes.findIndex(
      (c) => c._destroy !== 1 && c.card_id === card.card_id
    );
    if (card.id) {
      // mark to be deleted by rails
      card._destroy = 1;
      state.visualSchedule.visual_schedule_cards_attributes.splice(cardIndex, 1, card);
    } else {
      state.visualSchedule.visual_schedule_cards_attributes.splice(cardIndex, 1);
    }
  },

  addRevealImage(state, image) {
    // remove one at this position
    const existingIndex = state.visualSchedule.visual_schedule_reveal_images_attributes.findIndex(
      (img) => img._destroy !== 1 && img.position === image.position
    );
    if (existingIndex !== -1) state.visualSchedule.visual_schedule_reveal_images_attributes.splice(existingIndex, 1);
    state.visualSchedule.visual_schedule_reveal_images_attributes.push(image);
  },

  removeRevealImage(state, image) {
    const imgIndex = state.visualSchedule.visual_schedule_reveal_images_attributes.findIndex(
      (img) => img._destroy !== 1 && img.position === image.position
    );
    if (image.id) {
      // mark to be deleted by rails
      image._destroy = 1;
      console.log('index', imgIndex);
      state.visualSchedule.visual_schedule_reveal_images_attributes.splice(imgIndex, 1, image);
    } else {
      state.visualSchedule.visual_schedule_reveal_images_attributes.splice(imgIndex, 1);
    }
  },

  setAbilities(state, abilities) {
    state.can = abilities;
  },

  setCardTypes(state, types) {
    state.cardTypes = types;
  },

  setDefaultCards(state, cards) {
    state.defaultCards = cards;
  },

  setDefaultImages(state, images) {
    state.defaultImages = images;
  },

  setDirectUploadUrl(state, url) {
    state.directUploadUrl = url;
  },

  setDisplays(state, displays) {
    state.displayOptions = displays;
  },

  setSubCounters(state, subscounters) {
    state.subtaskCounterOptions = subscounters;
  },

  setTemplates(state, templates) {
    state.templateOptions = templates;
  },

  setUserId(state, userId) {
    state.userId = userId;
  },

  storeVisualScheduleChannel(state, subscription) {
    state.visualScheduleChannel = subscription;
  },

  updateVisualSchedule(state, { field, value }) {
    state.visualSchedule[field] = value;
    state.visualSchedule.visual_schedule_cards_attributes.forEach((card, i) => {
      if (card._destroy !== 1) card.position = i + 1;
    });
  },

  updateVisualScheduleContent(state, val) {
    state.updateVisualScheduleContent = val;
  },

  updateImageRevealerContent(state, val) {
    state.updateImageRevealerContent = val;
  },

  setVisualSchedule(state, visualSchedule) {
    state.visualSchedule = visualSchedule;
  },

  setVisualScheduleSharing(state, visualSchedule) {
    state.visualScheduleSharing = visualSchedule;
  },
};
